<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('ordine.misura')}}</h5>
        </div>
        <div slot="body">
            {{$t('ordine.misura_sel')}}:<br/>
            <ul>
                <li v-for="(measure, i) in this.measures">
                    <mcw-radio v-model="measure_id" name="misura" :id="'measure_'+i"
                               :label="measure.nome+' ('+measure.prezzo.toFixedGood(2)+' '+locale_currency+')'"
                               :value="measure.id.toString()"/>
                </li>
            </ul>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary" @click="$emit('close', parseInt(measure_id))">
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Modal from '../../partials/Modal';

export default {
    name: "ModalMeasure",
    components: {Modal},
    props: ['product', 'measureId'],
    data() {
        return {
            measure_id: this.measureId.toString()
        }
    },
    computed: {
        measures: function () {
            let measures = [];

            this.product.misure.forEach((measure) => {
                const firstPrice = this.product.prezzi.find((price) => {
                    return price.id_misura_tipologia_prodotto === measure.id;
                });

                if (firstPrice) {
                    let price = firstPrice.prezzo;
                    if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order_type)) {
                        if (firstPrice.prezzo_kmenu) price = firstPrice.prezzo_kmenu;
                    }

                    measures.push({
                        id: measure.id,
                        nome: measure.nome,
                        prezzo: price
                    });
                }
            });

            return measures;
        },
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        }),
        ...mapState('order', {
            order_type: state => state.type
        })
    }
}
</script>
